import { render, staticRenderFns } from "./PreguntaDialog.vue?vue&type=template&id=6be12ba0&"
import script from "./PreguntaDialog.vue?vue&type=script&lang=js&"
export * from "./PreguntaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports